<div class="page-wrapper" id="pageWrapper" [ngClass]="layoutClass">
  <app-header></app-header>
  <div class="page-body-wrapper" [class.scorlled]="hideScrollNavService.headerFixed == true">
    <!-- Mobile sidebar overlay -->
    <div 
      class="sidebar-overlay" 
      *ngIf="!navService.collapseSidebar && navService.screenWidth.value < 992"
      (click)="navService.collapseSidebar = true"
    ></div>
    <!-- Mobile sidebar toggle button (left side) -->
    <button 
      class="mobile-sidebar-toggle" 
      *ngIf="navService.collapseSidebar && navService.screenWidth.value < 992"
      (click)="navService.collapseSidebar = false"
      type="button"
      aria-label="Toggle sidebar"
    >
      <i class="fa fa-bars"></i>
    </button>
    <div
      class="sidebar-wrapper"
      [class.close_icon]="navService.collapseSidebar"
      [attr.data-layout]="layout.config.settings.icon"
    >
      <app-sidebar></app-sidebar>
    </div>
    <div class="page-body">
      @if(loading$ | async) {
        <app-loader></app-loader>
      }
      <router-outlet></router-outlet>
    </div>
    <footer
      class="footer"
      [class.footer-dark]="footerDark"
      [class.footer-light]="footerLight"
      [class.footer-fix]="footerFix"
    >
      <app-footer></app-footer>
    </footer>
  </div>
</div>
